export default __webpack_public_path__ + "static/media/warning--dual-path-cyclists-and-pedestrians--g1.c641917c.png";